import { TreeItems } from 'dnd-kit-sortable-tree';
import { Status } from 'services/api/api-client.types';
import { useMemo, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { getFilteredDocumentList } from './documentsObserver';
import { BaseNode } from './types/base';

export function useTreeSearch<T extends BaseNode>(
  items: TreeItems<T>,
  statusFilters?: Status[],
  onlyNotUpdatedVersion: boolean = false,
) {
  const [searchingName, setSearchingName] = useState('');
  const [debouncedSearchingName] = useDebounce(searchingName, 500);

  const filteredItems = useMemo(
    () =>
      getFilteredDocumentList(
        items,
        statusFilters ?? [],
        debouncedSearchingName,
        onlyNotUpdatedVersion,
      ),
    [items, statusFilters, debouncedSearchingName, onlyNotUpdatedVersion],
  );

  return {
    searchingName,
    setSearchingName,
    filteredItems,
  };
}
